
class RegisterIf {
    constructor(info) {
        if(info) {
            this.businessName = info.businessName;
            this.email = info.email;
            this.mobile = info.mobile;
            this.businessType = info.businessType;
            this.requestedFrom = "WEB"
        }
    }
}


class ContactUsIf {
    constructor(info) {
        if(info){
            this.fullName = info.fullname;
            this.email = info.email;
            this.mobile = info.mobile;
            this.feedback = info.message;
        }
    }
}

export default { RegisterIf};
export { RegisterIf, ContactUsIf};
